<div class="chip"
     appThrottleClick
     [ngClass]="{small, gray, red, filled, green, active, yellow,'gray-blue': grayBlue, 'active-gray-blue': activeGrayBlue, 'dark-blue': darkBlue, 'lightgray': lightgray}"
     (throttleClick)="emitClick()"
     [throttleTime]="1000">
     <mat-icon *ngIf="icon">{{icon}}</mat-icon>
    <ng-content></ng-content>
    <mat-icon *ngIf="iconAfter">{{iconAfter}}</mat-icon>
</div>
<div *ngIf="options && showOptions" [@fadeInOut]>
  <div class="options-area">
      <div *ngFor="let option of options">
        <div id="lnr-option-{{option.key}}" class="options-item" (click)="emitClickOption(option)">{{option.text}}</div>
      </div>
  </div>
</div>
